module.exports = "<button type=button class=button-beta data-modal=add-to-collection ng-click=toggleCollection()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + require("/var/app/node_modules/ushahidi-platform-pattern-library/assets/img/iconic-sprite.svg") + "#grid-three-up></use> </svg> <span class=button-label translate=set.add_to_collection>Add to collection</span> </button> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/common/collection-toggle/collection-toggle-button.html
// module id = 803
// module chunks = 0